module.exports = require('./dist/client').default;
